import { Tooltip } from '@analog/ui/src';
import { Card, SearchBox, Switches, Table } from 'components';
import { Skeleton } from 'components/Skeleton';
import { Chronicle, Shards } from 'pages';
import { SortColumnsTask, arrayOfSize, classes } from 'utils';

import { GmpTelemetry } from './GmpTelemetry';
import useGMPList from './useGMPList';

type GMPListProps = {
  section: 'messages' | 'chronicles' | 'shards';
  onSectionChange: (section: 'messages' | 'chronicles' | 'shards') => void;
};

const GMPList = ({ section, onSectionChange }: GMPListProps) => {
  const {
    tasksLoading,
    sortOrder,
    onSort,
    tasksData,
    pageSize,
    // FilterController,
    selectedTab,
    tabs,
    tableData,
    gmpStats,
    sections,
    handleTabChange,
    handleSectionTabChange,
  } = useGMPList({ section, onSectionChange });

  const rowClass = {
    gmpmessages:
      'md:grid-cols-[minmax(130px,15%)_minmax(180px,15%)_minmax(170px,25%)_minmax(170px,25%)_minmax(190px,10%)_minmax(114px,5%)_minmax(114px,5%)]',
    readmessagetasks:
      'md:grid-cols-[minmax(100px,15%)_minmax(120px,20%)_minmax(180px,20%)_minmax(160px,20%)_minmax(120px,15%)_minmax(120px,10%)]',
    submitgatewaytasks:
      'md:grid-cols-[minmax(100px,15%)_minmax(100px,15%)_minmax(180px,25%)_minmax(160px,25%)_minmax(140px,10%)_minmax(140px,10%)]',
  };

  const renderContent = () => {
    switch (section) {
      case 'messages':
        return (
          <div className="mt-8 md:mt-5">
            <Card extraClasses="flex gap-4 md:gap-[22px] flex-col p-3.5">
              <div className="flex flex-col md:flex-row items-center justify-between gap-5 md:gap-0">
                <span className="text-white md:text-xl text-lg font-normal leading-6 capitalize">
                  {tabs.find((tab) => tab.id === selectedTab)?.label}
                </span>
                <Switches
                  tabs={tabs.map((tab) => tab.label)}
                  selectedTab={tabs.find((tab) => tab.id === selectedTab)?.label || 'GMP Messages'}
                  setSelectedTab={handleTabChange}
                  className="flex flex-col rounded-[19px] md:flex-row md:rounded-full"
                />
              </div>
              <Table
                columns={tableData[selectedTab]?.columns || []}
                hasHeader
                data={
                  !tableData[selectedTab]?.isLoading
                    ? tableData[selectedTab]?.data?.data
                    : arrayOfSize(pageSize)
                }
                classNames={{
                  row: classes(
                    'last:border-none md:[&_>:nth-last-child(3)]:col-span-1 [&_>:nth-last-child(3)]:col-span-2 grid gap-x-4 grid-cols-2',
                    rowClass[selectedTab]
                  ),
                  bodyRow: '!py-4 items-start !h-auto',
                  bodyWrapper: 'min-h-[195px] border-b border-lightGray',
                  columns: 'justify-start',
                }}
                sortOptions={SortColumnsTask}
                sortOrder={sortOrder}
                onSort={onSort}
                isLoading={tableData[selectedTab]?.isLoading}
                alwaysShowHeader
              />
              <Skeleton.Provider isLoading={tasksLoading}>
                {(tasksLoading || !!tasksData?.listTasks?.data?.length) &&
                  tableData[selectedTab]?.PageController}
              </Skeleton.Provider>
            </Card>
          </div>
        );
      case 'chronicles':
        return <Chronicle />;
      case 'shards':
        return <Shards />;
      default:
        return null;
    }
  };

  return (
    <>
      <div className="flex flex-col gap-4 md:gap-8">
        <SearchBox defaultSearchType={'All'} />
        <GmpTelemetry {...gmpStats} />
        <div className="w-fit">
          <Switches
            tabs={sections.map((s) => s.label)}
            selectedTab={sections.find((s) => s.id === section)?.label || 'GMP'}
            setSelectedTab={(tab) => handleSectionTabChange(tab)}
            className="rounded-[19px] md:flex-row md:rounded-full"
          />
        </div>
      </div>
      {renderContent()}
      <Tooltip id={'signature'} />
    </>
  );
};

export default GMPList;
